import { defineComponent, ref, useTemplateRef, useModel, onMounted, nextTick, openBlock, createElementBlock, renderSlot, Fragment, renderList, normalizeClass, toDisplayString, createVNode, unref, mergeModels } from 'vue';
import { BlankType } from '../blank/blank-type.enum.js';
import Blank from '../blank/blank.js';
/* empty css                    */
/* empty css                                */
/* empty css                                  */
/* empty css                 */
/* empty css                                      */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "select-list",
  props: /* @__PURE__ */ mergeModels({
    dataList: { default: () => [] }
  }, {
    "modelValue": { default: void 0 },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const selectedItem = ref();
    const selectListDivRef = useTemplateRef("select-list-div");
    const model = useModel(__props, "modelValue");
    function selectHandler(item) {
      selectedItem.value = item;
      model.value = item.value;
    }
    function scrollIntoView() {
      if (selectListDivRef.value && __props.dataList.length > 0) {
        for (let i = 0; i < __props.dataList.length; i++) {
          if (__props.dataList[i].value === model.value) {
            selectListDivRef.value.children[i]?.scrollIntoView({
              behavior: "smooth"
            });
            return;
          }
        }
      }
    }
    function getSelectedItem() {
      return selectedItem.value;
    }
    onMounted(() => {
      nextTick(() => {
        scrollIntoView();
      });
    });
    __expose({
      getSelectedItem
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: "select-list-div",
        class: "se-select-list"
      }, [
        __props.dataList.length > 0 ? renderSlot(_ctx.$slots, "default", {
          key: 0,
          model: model.value,
          dataList: __props.dataList
        }, () => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.dataList, (item, index) => {
            return openBlock(), createElementBlock("p", {
              class: normalizeClass(["se-item", { activated: item.value === model.value }]),
              title: item.label,
              key: index,
              onClick: ($event) => selectHandler(item)
            }, toDisplayString(item.label), 11, ["title", "onClick"]);
          }), 128))
        ], true) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: "se-blank"
        }, [
          createVNode(unref(Blank), {
            type: unref(BlankType).LIST
          }, null, 8, ["type"])
        ]))
      ], 512);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=select-list.vue.js.map
